import { WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_FORM } from '../../webcomponents.constants';
import { WebAccessControlSchedulerFormComponent } from './component/WebAccessControlSchedulerFormComponent';

/**
 * The component for adding/editing web access control schedules
 * @link https://bitdefender.atlassian.net/wiki/spaces/GZDOCS/pages/1459750929/DRAFT+-+Web+Access+Control+Schedules+Page
 */
export { WebAccessControlSchedulerFormComponent };

window.customElements.define(WEB_COMPONENT_WEB_ACCESS_CONTROL_SCHEDULER_FORM, WebAccessControlSchedulerFormComponent);
